/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AssetMiniReference,
    AssetMiniReferenceFromJSON,
    AssetMiniReferenceFromJSONTyped,
    AssetMiniReferenceToJSON,
    MediaRootMiniReference,
    MediaRootMiniReferenceFromJSON,
    MediaRootMiniReferenceFromJSONTyped,
    MediaRootMiniReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface Subclip
 */
export interface Subclip {
    /**
     * 
     * @type {number}
     * @memberof Subclip
     */
    id: number;
    /**
     * 
     * @type {AssetMiniReference}
     * @memberof Subclip
     */
    asset: AssetMiniReference;
    /**
     * 
     * @type {AssetMiniReference}
     * @memberof Subclip
     */
    rendered?: AssetMiniReference;
    /**
     * 
     * @type {boolean}
     * @memberof Subclip
     */
    shared?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof Subclip
     */
    readonly date: Date;
    /**
     * 
     * @type {string}
     * @memberof Subclip
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof Subclip
     */
    tIn: number;
    /**
     * 
     * @type {number}
     * @memberof Subclip
     */
    tOut: number;
    /**
     * 
     * @type {number}
     * @memberof Subclip
     */
    readonly user: number;
    /**
     * 
     * @type {MediaRootMiniReference}
     * @memberof Subclip
     */
    root: MediaRootMiniReference;
}

export function SubclipFromJSON(json: any): Subclip {
    return SubclipFromJSONTyped(json, false);
}

export function SubclipFromJSONTyped(json: any, ignoreDiscriminator: boolean): Subclip {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'asset': AssetMiniReferenceFromJSON(json['asset']),
        'rendered': !exists(json, 'rendered') ? undefined : AssetMiniReferenceFromJSON(json['rendered']),
        'shared': !exists(json, 'shared') ? undefined : json['shared'],
        'date': (new Date(json['date'])),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'tIn': json['t_in'],
        'tOut': json['t_out'],
        'user': json['user'],
        'root': MediaRootMiniReferenceFromJSON(json['root']),
    };
}

export function SubclipToJSON(value?: Subclip | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'asset': AssetMiniReferenceToJSON(value.asset),
        'rendered': AssetMiniReferenceToJSON(value.rendered),
        'shared': value.shared,
        'name': value.name,
        't_in': value.tIn,
        't_out': value.tOut,
        'root': MediaRootMiniReferenceToJSON(value.root),
    };
}


